import ArrowButton from "@/components/Buttons/ArrowButton/ArrowButton";
import React from "react";
import { IEvent } from "../layout-blocks/Events/useEventData";
import S from "./EventCard.style";

export type Props = {
  item: IEvent;
  imageArray: {
    location: string;
    src: string;
  }[];
};

const EventCard = ({ item, imageArray }: Props) => {
  const image = imageArray.filter((image) => image.location === item.location);

  const {
    title,
    location,
    description,
    registration_url,
    information_url,
    datetime_from,
    datetime_to,
    is_invite_only,
  } = item;

  const button = {
    url: registration_url,
    target: "",
    title: "",
  };

  const formattedDate = (date: string) => {
    const stringDate =
      date.slice(0, 4) + "-" + date.slice(5, 7) + "-" + date.slice(8, 10);

    const newDate = new Date(stringDate).toLocaleDateString("sv-SE", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
    return newDate;
  };

  const formattedTime = (time1: string, time2: string) => {
    const fromTime = time1.slice(11, 16);
    const toTime = time2.slice(11, 16);
    return fromTime + " - " + toTime;
  };

  function truncate(str: string, no_words: number) {
    return str.split(" ").splice(0, no_words).join(" ");
  }

  return (
    <S.LinkWrapper href={information_url !== '' ? information_url : registration_url}>
      <S.Card backgroundImage={image[0] ? image[0].src : 'https://cms.radargrp.com/wp-content/uploads/2024/01/quino-al-JFeOy62yjXk-unsplash.jpg'}>
        <S.Category>
          {is_invite_only && <S.DetailsBig>Endast inbjudna</S.DetailsBig>}
        </S.Category>
        <S.HoverWrapper />
        <S.TextWrapper>
          <S.DetailsWrapper>
            <S.Icon>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.5 0C3.63261 0 3.75979 0.0526784 3.85355 0.146447C3.94732 0.240215 4 0.367392 4 0.5V1H12V0.5C12 0.367392 12.0527 0.240215 12.1464 0.146447C12.2402 0.0526784 12.3674 0 12.5 0C12.6326 0 12.7598 0.0526784 12.8536 0.146447C12.9473 0.240215 13 0.367392 13 0.5V1H14C14.5304 1 15.0391 1.21071 15.4142 1.58579C15.7893 1.96086 16 2.46957 16 3V14C16 14.5304 15.7893 15.0391 15.4142 15.4142C15.0391 15.7893 14.5304 16 14 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V5H16V4H0V3C0 2.46957 0.210714 1.96086 0.585786 1.58579C0.960859 1.21071 1.46957 1 2 1H3V0.5C3 0.367392 3.05268 0.240215 3.14645 0.146447C3.24021 0.0526784 3.36739 0 3.5 0V0Z"
                  fill="#F9F9F9"
                />
              </svg>
            </S.Icon>
            <S.Date>
              {datetime_from && formattedDate(String(datetime_from))}
            </S.Date>
            <S.Icon>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8ZM8 3.5C8 3.36739 7.94732 3.24021 7.85355 3.14645C7.75979 3.05268 7.63261 3 7.5 3C7.36739 3 7.24021 3.05268 7.14645 3.14645C7.05268 3.24021 7 3.36739 7 3.5V9C7.00003 9.08813 7.02335 9.17469 7.06761 9.25091C7.11186 9.32712 7.17547 9.39029 7.252 9.434L10.752 11.434C10.8669 11.4961 11.0014 11.5108 11.127 11.4749C11.2525 11.4391 11.3591 11.3556 11.4238 11.2422C11.4886 11.1288 11.5065 10.9946 11.4736 10.8683C11.4408 10.7419 11.3598 10.6334 11.248 10.566L8 8.71V3.5Z"
                  fill="#F9F9F9"
                />
              </svg>
            </S.Icon>
            <S.Date>
              {datetime_from && formattedTime(datetime_from, datetime_to)}
            </S.Date>
          </S.DetailsWrapper>
          <S.DetailsWrapper>
            <S.Icon>
              <svg
                width="12"
                height="16"
                viewBox="0 0 12 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 16C6 16 12 10.314 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 2.37122e-08 4.4087 0 6C0 10.314 6 16 6 16ZM6 9C5.20435 9 4.44129 8.68393 3.87868 8.12132C3.31607 7.55871 3 6.79565 3 6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3C6.79565 3 7.55871 3.31607 8.12132 3.87868C8.68393 4.44129 9 5.20435 9 6C9 6.79565 8.68393 7.55871 8.12132 8.12132C7.55871 8.68393 6.79565 9 6 9Z"
                  fill="#F9F9F9"
                />
              </svg>
            </S.Icon>
            <S.Date>{location && location}</S.Date>
          </S.DetailsWrapper>
          <S.Title>{title && truncate(title, 8)}</S.Title>
          <S.Line />
          <S.PWrapper>
            <S.Paragraph
              dangerouslySetInnerHTML={{
                __html: description && description,
              }}
            />
          </S.PWrapper>
          <S.ArrowWrapper>
            <ArrowButton button={button} backgroundColor="black" noA={true} />
          </S.ArrowWrapper>
        </S.TextWrapper>
      </S.Card>
    </S.LinkWrapper>
  );
};

export default EventCard;
